/**
 * @ignore
 * Created by daletan on 8/25/16.
 */

'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');

const get = require('lodash.get');

// Stores
const ItemStore = require('../../stores/ItemStore.es');
const UserStore = require('../../../global/stores/UserStore.es');

const { OPEN_DETAILS_FROM_SIDEBAR } = require('../../constants/shippingConstants');

// Components
const VerifiedTradePromo = require('./VerifiedTradePromo/VerifiedTradePromo').default;
const QuotePrimary = require('./QuotePrimary');
const ShippingDetailsLink = require('./ShippingDetailsLink');

// Helpers
const provideContext = require('fluxible-addons-react/provideContext');
const connectToStores = require('fluxible-addons-react/connectToStores');
const { filterQuotes } = require('./shippingHelpers');
const copy = require('./Blurb.json');

const ShippingBlurb = props => {
    const canShowBlurb = !(props.isSold
        || props.isUnlisted
        || props.hidePrice
        || !props.currency
        || !props.relayItem);
    const { user = null, quotes, currency, context, userId, itemId, dealerPk, viewer,
        favoriteDealer, favoriteDealerCta, dealerData, pagePosition } = props;

    if (canShowBlurb) {
        const hasQuote = filterQuotes(quotes.domestic).length || filterQuotes(quotes.local).length;
        const canRequestShippingQuote = get(user, 'canRequestShippingQuote');

        const labelText = hasQuote ? copy.hasQuote : copy.noQuote;
        const link = <a href={labelText.href}>{canRequestShippingQuote ? labelText.canRequest : labelText.cannotRequest}</a>;

        return (
            <div className="pdp-shipping-blurb">
                <QuotePrimary currency={currency} quotes={quotes} />
                <VerifiedTradePromo userId={userId} itemId={itemId} viewer={viewer} />
                {!props.isOnHold &&
                    <ShippingDetailsLink
                        pagePosition={`${pagePosition}-blurb`}
                        userId={userId}
                        itemId={itemId}
                        dealerPk={dealerPk}
                        viewer={viewer}
                        link={link}
                        context={context}
                        user={user}
                        quotes={quotes}
                        customQuoteAvailable={canRequestShippingQuote}
                        regionType="DOMESTIC"
                        source={OPEN_DETAILS_FROM_SIDEBAR}
                        favoriteDealer={favoriteDealer}
                        favoriteDealerCta={favoriteDealerCta}
                        dealerData={dealerData}
                        trackingLocation="pdp sidebar"
                        item={props.relayItem}
                    />
                }
            </div>
        );
    }
    return <div className="pdp-shipping-blurb no-data"></div>;
};

ShippingBlurb.propTypes = {
    context: PropTypes.object,
    quotes: PropTypes.object.isRequired,
    user: PropTypes.object,
    userId: PropTypes.string,
    itemId: PropTypes.string,
    dealerPk: PropTypes.string,
    viewer: PropTypes.object,
    relayItem: PropTypes.object,
    currency: PropTypes.string.isRequired,
    isOnHold: PropTypes.bool,
    isSold: PropTypes.bool,
    isUnlisted: PropTypes.bool,
    hidePrice: PropTypes.bool,
    favoriteDealer: PropTypes.object,
    favoriteDealerCta: PropTypes.object,
    dealerData: PropTypes.object,
    pagePosition: PropTypes.string
};

module.exports = Relay.createContainer(provideContext(connectToStores(
    ShippingBlurb,
    [
        ItemStore,
        UserStore
    ],
    context => {
        const userStore = context.getStore(UserStore);
        const itemStore = context.getStore(ItemStore);
        return ({
            currency: userStore.getCurrency(),
            isOnHold: itemStore.getIsOnHold(),
            isSold: itemStore.getIsSold(),
            isUnlisted: itemStore.getIsUnlisted(),
            hidePrice: itemStore.getHidePrice()

        });
    }
)), {
    initialVariables: {
        userId: null,
        itemId: null
    },
    fragments: {
        user: ({itemId, userId}) => Relay.QL`
            fragment on User {
                ${ShippingDetailsLink.getFragment('user', {itemId, userId})}
                canRequestShippingQuote: hasPermission(name: "B_REQUEST_SHIPPING_QUOTE")
            }
        `,
        relayItem: () => Relay.QL`
            fragment on Item {
                ${ShippingDetailsLink.getFragment('item')}
            }
        `,
        viewer: ({itemId, userId}) => Relay.QL`
            fragment on Viewer {
                ${ShippingDetailsLink.getFragment('viewer', {itemId, userId})}
                ${VerifiedTradePromo.getFragment('viewer', {itemId, userId})}
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Shipping/Blurb.jsx